import { optionsMap, flattenObject } from 'pro-gallery-lib';
import { PLACEMENT_TO_TEXT_POSITION_MAP, PLACEMENT_TO_FLEX_MAP } from '../consts';
import withDraggableOrder from './info/withDraggableOrder';

// import { OptionTypeDraggable, OptionTypeText } from '../../../ProGallery.types';

export const INFO = {
  NEW_EXTERNAL_INFO_TOGGLE: `controllers_layoutParams_info_newInfo_external_enabled`,
  WIDTH_IN_PIXEL: `controllers_layoutParams_info_width__pixel`,
  WIDTH_IN_PERCENT: `controllers_layoutParams_info_width_percent`,
  VERTICAL_ALIGN: `controllers_layoutParams_info_verticalAlignment`,
  HORIZONTAL_ALIGN: `controllers_layoutParams_info_horizontalAlignment`,
  VERTICAL_PADDING: `controllers_layoutParams_info_verticalPadding`,
  HORIZONTAL_PADDING: `controllers_layoutParams_info_horizontalPadding`,
  ALLOW_TITLE: `controllers_layoutParams_info_allowTitle`,
  ALLOW_DESCRIPTION: `controllers_layoutParams_info_allowDescription`,
  ALLOW_TITLE_AND_DESCRIPTION: `controllers_layoutParams_info_allowTitleAndDescription`,
  EXTERNAL_MASTER_INFO_ENABLED: `controllers_layoutParams_infoElementOptions_external_enabled`,
  EXTERNAL_MASTER_INFO_ORDER: `controllers_layoutParams_infoElementOptions_external_order`,
  EXTERNAL_INFO_PLACEMENT: `controllers_layoutParams_external_info_placement`,
  ORIGINAL_INFO_PLACEMENT: `layoutParams_info_placement`,
  USE_NEW_INFO: `controllers_experimental_useNewInfo`,
  INTERNAL_MASTER_INFO_ENABLED: `controllers_layoutParams_infoElementOptions_internal_enabled`,
  INTERNAL_MASTER_INFO_ORDER: `controllers_layoutParams_infoElementOptions_internal_order`,
  EXTERNAL_SOCIAL_BUTTONS_ALIGNMENT: 'controllers_layoutParams_external_info_SocialButtonsHorizontalAlignment',
  INTERNAL_SOCIAL_BUTTONS_ALIGNMENT: 'controllers_layoutParams_internal_info_SocialButtonsHorizontalAlignment',
  EXTERNAL_INFO_HEIGHT: 'layoutParams_info_height'
};
export const [ExternalMasterInfoOption, ExternalMasterInfoOptionEnabledKey] = createMasterInfoOption(INFO.EXTERNAL_MASTER_INFO_ORDER, INFO.EXTERNAL_MASTER_INFO_ENABLED);
export const [InternalMasterInfoOption, InternalMasterInfoOptionEnabledKey] = createMasterInfoOption(INFO.INTERNAL_MASTER_INFO_ORDER, INFO.INTERNAL_MASTER_INFO_ENABLED);
function getFlattenedWithDraggable(internalOrExternal, option) {
  return withDraggableOrder(option, order => {
    const fixedOrder = {
      top: order.top.join(','),
      middle: order.middle.join(','),
      bottom: order.bottom.join(',')
    };
    return flattenObject({
      infoElementsOptions: {
        [internalOrExternal]: {
          order: fixedOrder
        }
      }
    });
  });
}
function getSocialButtonsAlignmentHandler(internalOrExternal) {
  return value => {
    const socialObj = {
      socialParams: {
        horizontalAlignment: value.toLowerCase()
      }
    };
    return flattenObject({
      infoElementsOptions: {
        [internalOrExternal]: socialObj
      }
    });
  };
}
function getEnabledHandler(internalOrExternal) {
  return value => {
    try {
      const enabledData = value.split(',');
      const enabledObj = {
        enabled: {
          Title: enabledData.includes('Title'),
          Description: enabledData.includes('Description'),
          CustomButton: enabledData.includes('CustomButton'),
          Social: enabledData.includes('Social')
        },
        socialParams: {
          options: {
            loveButton: false,
            allowSocial: false,
            loveCounter: false,
            allowDownload: true
          }
        }
      };
      return flattenObject({
        infoElementsOptions: {
          [internalOrExternal]: enabledObj
        }
      });
    } catch (e) {
      console.log('error parsing json', e);
      return {};
    }
  };
}
function createMasterInfoOption(key, enabledKey) {
  // eslint parsing error on array tupple [OptionTypeDraggable, OptionTypeText]
  return [{
    key,
    enabledKey,
    title: key.includes('internal') ? 'On Image' : 'Around Image',
    type: 'DRAGGABLE',
    options: [{
      type: 'section',
      key: 'top',
      label: 'top'
    }, {
      type: 'section',
      key: 'middle',
      label: 'middle'
    }, {
      type: 'section',
      key: 'bottom',
      label: 'bottom'
    }, {
      type: 'item',
      key: 'Title',
      label: 'Title',
      defaultSection: 'top'
    }, {
      type: 'item',
      key: 'Description',
      label: 'Description',
      defaultSection: 'top'
    }, {
      type: 'item',
      key: 'CustomButton',
      label: 'CustomButton',
      defaultSection: 'top'
    }, {
      type: 'item',
      key: 'Social',
      label: 'Social',
      defaultSection: 'bottom'
    }],
    enabledKeyDefualt: '',
    controller: 'DRAGGABLE',
    default: 'top,Title,Description,CustomButton,middle,bottom,Social'
  }, {
    key: enabledKey,
    type: 'TEXT',
    title: '',
    default: ''
  }];
}
export const INFO_CONTROLLERS = {
  [INFO.EXTERNAL_INFO_PLACEMENT]: (value, options) => {
    function newInfoEnabledByUser() {
      return options.controllers_experimental_useNewInfo === 'true';
    }

    // READ_THIS_BEFORE_CHANGING:
    // Since the core does not know the new info elements, we control the rendering of external box using the info.placement. SHOW_ON_HOVER on core language means that there will not be an external box renderer
    // Old code commented because the old product (decided by Nir and Yonatan) was that when no external info is enabled then there is no box. Turns out that is not the correct product and we want an empty box if the user decided so (using the info box height)
    if (newInfoEnabledByUser()) {
      // const someExternalInfosEnabled = options.infoElementsOptions_external_enabled_Description || options.infoElementsOptions_external_enabled_Title
      const someExternalInfosEnabled = true;
      const titlePlacementValue = someExternalInfosEnabled ? value : 'OVERLAY';
      return {
        [optionsMap.layoutParams.info.placement]: titlePlacementValue
      };
    } else {
      return {
        [optionsMap.layoutParams.info.placement]: options.layoutParams_info_placement
      };
    }
  },
  [INFO.WIDTH_IN_PIXEL]: (value, options) => {
    const unitSize = options[optionsMap.layoutParams.info.sizeUnits];
    if (unitSize !== 'PIXEL' || value === undefined) {
      return;
    }
    return {
      [optionsMap.layoutParams.info.width]: value
    };
  },
  [INFO.EXTERNAL_MASTER_INFO_ENABLED]: getEnabledHandler('external'),
  [INFO.EXTERNAL_MASTER_INFO_ORDER]: getFlattenedWithDraggable('external', ExternalMasterInfoOption),
  [INFO.INTERNAL_MASTER_INFO_ENABLED]: getEnabledHandler('internal'),
  [INFO.INTERNAL_MASTER_INFO_ORDER]: getFlattenedWithDraggable('internal', InternalMasterInfoOption),
  [INFO.WIDTH_IN_PERCENT]: (value, options) => {
    const unitSize = options[optionsMap.layoutParams.info.sizeUnits];
    if (unitSize !== 'PERCENT' || value === undefined) {
      return;
    }
    return {
      [optionsMap.layoutParams.info.width]: value
    };
  },
  [INFO.HORIZONTAL_ALIGN]: (value, _options) => {
    if (value === undefined) {
      return;
    }
    return {
      galleryHorizontalAlign: PLACEMENT_TO_FLEX_MAP[value],
      galleryTextAlign: PLACEMENT_TO_TEXT_POSITION_MAP[value]
    };
  },
  [INFO.ALLOW_TITLE_AND_DESCRIPTION]: value => {
    const controllers_layoutParams_info_allowTitle = value.includes(INFO.ALLOW_TITLE);
    const controllers_layoutParams_info_allowDescription = value.includes(INFO.ALLOW_DESCRIPTION);
    return {
      controllers_layoutParams_info_allowTitle,
      controllers_layoutParams_info_allowDescription
    };
  },
  [INFO.EXTERNAL_SOCIAL_BUTTONS_ALIGNMENT]: getSocialButtonsAlignmentHandler('external'),
  [INFO.INTERNAL_SOCIAL_BUTTONS_ALIGNMENT]: getSocialButtonsAlignmentHandler('internal'),
  [INFO.NEW_EXTERNAL_INFO_TOGGLE]: (value, options) => {
    // ORDER MATTERS> THIS MUST BE AFTER INFO.EXTERNAL_INFO_PLACEMENT
    function newInfoEnabledByUser() {
      return options.controllers_experimental_useNewInfo === 'true';
    }
    if (newInfoEnabledByUser()) {
      if (!value) {
        return {
          [optionsMap.layoutParams.info.placement]: 'OVERLAY'
        };
      } else {
        return {};
      }
    } else {
      return {};
    }
  }
};
//# sourceMappingURL=info.js.map